import { render } from "./Shareholders.vue?vue&type=template&id=2344cff4&scoped=true&ts=true"
import script from "./Shareholders.vue?vue&type=script&lang=ts"
export * from "./Shareholders.vue?vue&type=script&lang=ts"

import "./Shareholders.vue?vue&type=style&index=0&id=2344cff4&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2344cff4"]])

export default __exports__